import { render, staticRenderFns } from "./GastroAnamnesiFamiliareEditComponent.vue?vue&type=template&id=2930693c"
import script from "./GastroAnamnesiFamiliareEditComponent.vue?vue&type=script&lang=js"
export * from "./GastroAnamnesiFamiliareEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports